import React from 'react';
import { Controller } from 'react-hook-form';
import { InputSwitch } from 'primereact/inputswitch';
import { RadioButton } from 'primereact/radiobutton';
import { useHistory } from 'react-router-dom';
import ImageComponent from 'shared/ImageComponent';
import { getTenantIdFromLS } from 'utils/localStorageUtils';
import { handleRedirection } from 'utils/utils';

function SelectedGroups(props) {
  const { selectedGroups, control, watch, setValue } = props;
  const history = useHistory();
  const tenantId = getTenantIdFromLS();
  const groups = watch('groups') || selectedGroups;

  const handleSendReminderChange = (id, value) => {
    const updatedGroups = [...groups];
    updatedGroups[id].send_reminder = value;
    setValue('groups', updatedGroups);
  };

  return (
    <div className="d-flex align-items-center py-2">
      <div className="col-12">
        {/* Desktop Table */}
        <div className="selected-firm-users-table d-none d-md-block">
          <table className="table attendees-table">
            <thead>
              <tr>
                <th className="attendee-names">Groups</th>
                <th className="text-center">
                  <label className="text-muted">Required</label>
                </th>
                <th className="text-center">
                  <label className="text-muted">Optional</label>
                </th>
                <th className="text-center">
                  <label className="text-muted">Send Reminder</label>
                </th>
              </tr>
            </thead>
            <tbody>
              {selectedGroups.map((item, id) => {
                return (
                  <tr key={id}>
                    <td className="attendee-names">
                      <div
                        className="d-flex text-primary-dark text-decoration-none cursor-pointer"
                        onClick={() => {
                          let url = '/settings/groups';
                          handleRedirection(history, url);
                        }}
                      >
                        <ImageComponent
                          filePath={`${tenantId}/${item?.client_cognito_username}/profile_image`}
                          fileName={item.group_name}
                          fileSize="small.jpg"
                        />
                        <div className="mx-2 align-items-center d-flex">{item.group_name}</div>
                      </div>
                    </td>
                    <Controller
                      name={`groups.${id}.is_attendance_required`}
                      control={control}
                      defaultValue="optional"
                      render={({ field }) => (
                        <>
                          <td className="text-center">
                            <div>
                              <RadioButton
                                inputId={`group-required-${id}`}
                                name={field.name}
                                value="required"
                                checked={field.value === 'required'}
                                onChange={(e) => field.onChange(e.value)}
                              />
                            </div>
                          </td>
                          <td className="text-center">
                            <div className="p-field-radiobutton">
                              <RadioButton
                                inputId={`group-optional-${id}`}
                                name={field.name}
                                value="optional"
                                checked={field.value === 'optional'}
                                onChange={(e) => field.onChange(e.value)}
                              />
                            </div>
                          </td>
                        </>
                      )}
                    />
                    <Controller
                      name={`groups.${id}.send_reminder`}
                      control={control}
                      render={({ field }) => (
                        <td className="text-center">
                          <InputSwitch
                            id={field.name}
                            value={field.value}
                            checked={field.value}
                            onChange={(e) => {
                              field.onChange(e.value);
                              handleSendReminderChange(id, e.value);
                            }}
                            placeholder="Meeting URL"
                          />
                        </td>
                      )}
                    />
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* Mobile Responsive Card List */}
        <div className="selected-firm-users-mobile d-block d-md-none">
          {selectedGroups.map((item, id) => (
            <div className="firm-user-mobile-row d-flex flex-wrap mb-3 p-2 firm-user-mobile-gap" key={id}>
              <div className="col-4 firm-user-mobile-label">Group</div>
              <div className="col-8 d-flex align-items-center">
                <div
                  className="d-flex text-primary-dark text-decoration-none cursor-pointer"
                  onClick={() => {
                    let url = '/settings/groups';
                    handleRedirection(history, url);
                  }}
                >
                  <ImageComponent
                    filePath={`${tenantId}/${item?.client_cognito_username}/profile_image`}
                    fileName={item.group_name}
                    fileSize="small.jpg"
                  />
                  <div className="mx-2 align-items-center d-flex">{item.group_name}</div>
                </div>
              </div>
              <div className="col-4 firm-user-mobile-label">Required</div>
              <div className="col-8 d-flex align-items-center">
                <Controller
                  name={`groups.${id}.is_attendance_required`}
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <RadioButton
                      inputId={`group-required-mobile-${id}`}
                      name={field.name}
                      value="required"
                      checked={field.value === 'required'}
                      onChange={(e) => field.onChange(e.value)}
                    />
                  )}
                />
              </div>
              <div className="col-4 firm-user-mobile-label">Optional</div>
              <div className="col-8 d-flex align-items-center">
                <Controller
                  name={`groups.${id}.is_attendance_required`}
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <RadioButton
                      inputId={`group-optional-mobile-${id}`}
                      name={field.name}
                      value="optional"
                      checked={field.value === 'optional'}
                      onChange={(e) => field.onChange(e.value)}
                    />
                  )}
                />
              </div>
              <div className="col-4 firm-user-mobile-label">Send Reminder</div>
              <div className="col-8 d-flex align-items-center">
                <Controller
                  name={`groups.${id}.send_reminder`}
                  control={control}
                  render={({ field }) => (
                    <InputSwitch
                      id={field.name}
                      value={field.value}
                      checked={field.value}
                      onChange={(e) => {
                        field.onChange(e.value);
                        handleSendReminderChange(id, e.value);
                      }}
                      placeholder="Meeting URL"
                    />
                  )}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SelectedGroups;
